// ══════════════════════════════════════════════════════════════
//  entorno.js — la UNICA lectura del entorno de build (migracion a Vite, 2026-09-06)
//
//  Vite expone las variables REACT_APP_* en import.meta.env (envPrefix en
//  vite.config.mjs; el nombre no cambio para no tocar Vercel ni los .env).
//  Node (el MCP de mcp/, los scripts) las tiene en process.env. Este modulo
//  resuelve las dos fuentes una sola vez; nadie mas lee import.meta.env ni
//  process.env directamente.
//
//  Se lee POR PROPIEDAD (import.meta.env.X) y nunca el objeto entero: Vite sustituye
//  cada propiedad por su literal, asi que al bundle solo viajan estas cuatro claves y
//  no toda variable REACT_APP_* que exista en el entorno de Vercel. En Node
//  import.meta.env es undefined y la primera lectura lanza: el catch deja el objeto
//  vacio y se cae a process.env.
// ══════════════════════════════════════════════════════════════
let vite = {};
try {
  vite = {
    REACT_APP_SUPABASE_URL: import.meta.env.REACT_APP_SUPABASE_URL,
    REACT_APP_SUPABASE_KEY: import.meta.env.REACT_APP_SUPABASE_KEY,
    REACT_APP_SITIO_URL: import.meta.env.REACT_APP_SITIO_URL,
    PROD: import.meta.env.PROD,
  };
} catch (e) { vite = {}; }
const node = (typeof process !== 'undefined' && process.env) || {};
const leer = (clave) => (vite[clave] !== undefined ? vite[clave] : node[clave]);

export const ENTORNO = Object.freeze({
  SUPABASE_URL: leer('REACT_APP_SUPABASE_URL'),
  SUPABASE_KEY: leer('REACT_APP_SUPABASE_KEY'),
  SITIO_URL: leer('REACT_APP_SITIO_URL'),
  // true solo en el build de produccion (vite build); en `vite`, en vitest y en Node es false.
  PRODUCCION: vite.PROD !== undefined ? !!vite.PROD : node.NODE_ENV === 'production',
});
